import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/uiKit/atoms/Button.tsx';
import { CardFooter } from '@/uiKit/atoms/card/CardFooter.tsx';
import {
  GeneratePrescriptionInfo,
  PrescriptionInfo,
} from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfo.ts';
import { PRESCRIPTION_INFO_FORM_ID } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfoForm.tsx';

export type PrescriptionInfoFormActionsProps = {
  onBack?: (data: Partial<GeneratePrescriptionInfo>) => void;
  submitTitle: string;
};

export const PrescriptionInfoFormActions: React.FC<
  PrescriptionInfoFormActionsProps
> = ({ onBack, submitTitle }) => {
  const { t } = useTranslation();
  const formContext = useFormContext<PrescriptionInfo>();
  const uploadedPrescription = formContext.watch('file');
  const nextTitle =
    uploadedPrescription && uploadedPrescription.name
      ? submitTitle
      : t('button.generate');

  return (
    <CardFooter>
      <Button
        variant="outlined"
        id="patient-info-cancel"
        onClick={() =>
          onBack &&
          onBack(formContext.getValues() as Partial<GeneratePrescriptionInfo>)
        }
      >
        {t('button.back')}
      </Button>
      <Button
        form={PRESCRIPTION_INFO_FORM_ID}
        id="patient-info-next"
        type="submit"
        variant="contained"
      >
        {nextTitle}
      </Button>
    </CardFooter>
  );
};
